import React from 'react';
import { AlertTriangle, Info } from 'lucide-react';
import { SpecMismatchView, gatingSpecMismatches, specMismatchLabel } from './discoveryModel';

/**
 * The deterministic spec check's finding on a supplier card, so the buyer
 * never shortlists a substitute unseen. A higher rating than asked ("Offers
 * 40C — above your 30C") reads as information; anything below or different
 * reads as a warning. Renders nothing when the offer matches the BOM.
 */
export const SpecMismatchNote: React.FC<{ mismatches: SpecMismatchView[]; className?: string }> = ({
  mismatches,
  className = '',
}) => {
  if (mismatches.length === 0) return null;
  const label = specMismatchLabel(mismatches);
  const warn = gatingSpecMismatches(mismatches).length > 0;
  const Icon = warn ? AlertTriangle : Info;
  return (
    <div
      className={`flex items-start gap-s2 text-meta font-semibold ${warn ? 'text-warn-ink' : 'text-ink-secondary'} ${className}`}
      title={label}
    >
      <Icon className="mt-[2px] h-3 w-3 shrink-0" aria-hidden />
      <span>{label}</span>
    </div>
  );
};

export default SpecMismatchNote;
